<template>
  <div class="billList">
    <!-- 选择日期 -->
    <div :span="17" class="chooseDate">
      <div class="search_content">
        <img src="@assets/img/calendar2.png" />
        <a-range-picker v-model:value="pickerDate" separator="至" valueFormat="YYYY-MM-DD" @change="dateChange" />
      </div>
    </div>
    <!--  -->
    <a-table
      :columns="columns"
      bordered
      :data-source="amountList"
      :pagination="false"
      :row-key="(r) => r.id"
      :loading="loading"
      style="font-size:12px"
    >
      <template v-slot:isFinishValue="{ text, record }">
        <div>{{ record.isFinishValue }}</div>
      </template>
      <template v-slot:operation="{ text, record }">
        <a @click="toDetail(record)" class="handleBtn">
          账单明细
        </a>
        <a @click="handleDownload(record)" class="handleBtn">
          下载
        </a>
       <!-- <a @click="createBill(record)" class="handleBtn">
          导入账单
        </a>-->
      </template>
    </a-table>
    <a-pagination
      v-show="amountList.length"
      v-model:current="current"
      :total="total"
      :page-size="10"
      @change="pageChange"
      :show-total="(total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`"
    />
    <!-- 导入对账单 -->
    <a-modal v-model:visible="createVisible" title="导入账单" :footer="null" class="creatModel">
      <a-spin :spinning="createSpinning">
        <a-form layout="inline">
          <a-row type="flex" justify="space-around" align="middle" class="creatRow">
            <a-col :span="4">
              <CloudDownloadOutlined />
            </a-col>
            <a-col :span="20">
              <p>填写导入数据信息</p>
              <p>请按照数据模板的格式准备导入数据，模板中的表头名称不可更改，表头行不能删除</p>
              <p @click="templateDownload">下载模板</p>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-around" align="middle" class="creatRow">
            <a-col :span="4">
              <CloudUploadOutlined />
            </a-col>
            <a-col :span="20">
              <p>上传填好的信息表</p>
              <p>文件后缀名必须为xls 或xlsx （即Excel格式），文件大小不得大于10M，最多支持导入3000条数据</p>
              <a-upload :fileList="fileList" :remove="handleRemove" :beforeUpload="beforeUpload">
                <p class="handle">上传文件</p>
              </a-upload>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-around" align="middle" class="tipRow">
            <a-col :span="3">
              <ExclamationCircleOutlined />
            </a-col>
            <a-col :span="21">
              <p>特别提示</p>
              <p>单号不能重复</p>
            </a-col>
          </a-row>

          <a-form-item>
            <a-button type="primary" @click="createCancel">
              取消
            </a-button>
          </a-form-item>
          <a-form-item>
            <a-button @click="handleUpload">上传</a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import myApi from "@axios/my";
import { Modal, destroyAll, notification, message } from "ant-design-vue";
import {
  CloudDownloadOutlined,
  CloudUploadOutlined,
  ExclamationCircleOutlined,
  UploadOutlined
} from "@ant-design/icons-vue";
import { exportOut } from "@axios/exportOut";

export default {
  name: "billList",
  components: {
    CloudDownloadOutlined,
    CloudUploadOutlined,
    ExclamationCircleOutlined,
    UploadOutlined
  },
  setup() {
    let router = useRouter();
    const route = useRoute();

    // 日期
    let pickerDate = ref([]);
    const dateChange = (date) => {
      getAmountList();
    };

    let loading = ref(false);

    let amountList = ref([]);

    let current = ref(1);
    let total = ref(0);

    const getAmountList = () => {
      if (loading.value) {
        return;
      }
      let params = {
        size: 10,
        currentPage: current.value
      };
      if (pickerDate.value.length) {
        params.checkBegin = pickerDate.value[0];
        params.checkEnd = pickerDate.value[1];
      }
      loading.value = true;
      myApi
        .getBillList(params)
        .then((res) => {
          amountList.value = res.data;
          current.value = res.currentPage;
          total.value = res.total;

          loading.value = false;
        })
        .catch(() => {
          loading.value = false;
        });
    };

    const pageChange = (page) => {
      current.value = page;
      getAmountList();
    };

    // 详情
    const toDetail = (row) => {
      console.log(row);
      router.push({
        name: "billListDetail",
        query: {
          id: row.id,
          billNo: row.billNo,
          supplierId: row.supplierId,
          checkTime: row.checkTime,
            checkDate: row.checkDate
        }
      });
    };

    getAmountList();

    // 导出
    const handleDownload = (item) => {
      let params = {
        billNo: item.billNo
      };
      let fileName = "帐单-" + item.billNo;
      exportOut(
        params, // 导出请求参数
        "/business-finance/distributor/bill/download", // 接口地址
        fileName // 导出文件名字
      );
    };

    // 创建对账单
    let createVisible = ref(false);
    let id = ref("");
    const createBill = (item) => {
      createVisible.value = true;
      id.value = item.id;
    };
    const createCancel = () => {
      createVisible.value = false;
    };
    // 下载模板
    const templateDownload = () => {
      let params = {};
      let fileName = "模板";
      exportOut(
        params, // 导出请求参数
        "/business-finance/distributor/bill/download/template", // 接口地址
        fileName // 导出文件名字
      );
    };
    // 文件上传
    let createSpinning = ref(false);
    let fileList = ref([]);
    const handleRemove = (file) => {
      // 移除文件时，要重新给fileList赋值
      let arr = [];
      for (let i = 0; i < fileList.value.length; i++) {
        if (fileList.value[i].uid !== file.uid) {
          arr.push(fileList.value[i]);
        }
      }
      fileList.value = arr;
      console.log(fileList.value);
    };
    // 上传前校验
    const beforeUpload = (file) => {
      console.log(file);
      // const isXlsOrXlsx = file.type === "xls" || file.type === "xlsx";
      // if (!isXlsOrXlsx) {
      //   message.error("只能上传xls 或xlsx （即Excel格式）!");
      // }
      // const isLt10M = file.size / 1024 / 1024 < 10;
      // if (!isLt10M) {
      //   message.error("文件大小不得大于10M!");
      // }
      // return isXlsOrXlsx && isLt10M;
      fileList.value = [...fileList.value, file];
      return false;
    };
    // 上传
    const handleUpload = () => {
      console.log(id.value);
      createSpinning.value = true;
      console.log(fileList.value);
      const formData = new FormData();
      fileList.value.forEach((file) => {
        formData.append("file", file);
        console.log(file);
      });
      formData.append("id", id.value);
      myApi.importBillDetail(formData).then((res) => {
        console.log(res);
        fileList.value = [];
        message.success("上传成功");
        createSpinning.value = false;
        createVisible.value = false;
        getList();
      });
    };

    return {
      toDetail,
      pageChange,
      total,
      amountList,
      loading,
      pickerDate,
      dateChange,
      current,
      columns: [
          {
              title: "结算单编号",
              dataIndex: "billNo",
              width: 100,
              align: "center"
              // className: `${"underlineStyle"}`
          },
          {
              title: "结算金额",
              dataIndex: "settlementAmount",
              width: 100,
              align: "center"
              // className: `${"underlineStyle"}`
          },
          {
              title: "出票金额",
              dataIndex: "outTicketAmount",
              // width: 80,
              align: "center"
          },
          {
              title: "出票数",
              dataIndex: "outTicketNum",
              // width: 80,
              align: "center"
          },
          {
              title: "退票金额",
              dataIndex: "returnTicketAmount",
              // width: 80,
              align: "center"
          },
          {
              title: "退票数",
              dataIndex: "returnTicketNum",
              // width: 80,
              align: "center"
          },
          {
              title: "是否完结",
              dataIndex: "isFinishValue",
              width: 60,
              align: "center",
              slots: { customRender: "isFinishValue" }
          },

        {
          title: "生成时间",
          dataIndex: "createTime",
          width: 100,
          align: "center"
          // className: `${"underlineStyle"}`
        },
          {
              title: "对账时段",
              dataIndex: "checkDate",
              width: 200,
              align: "center",
              //slots: { customRender: "checkDate" },
          },


        /*{
          title: "保单额",
          dataIndex: "insuranceAmount",
          // width: 80,
          align: "center"
        },*/
        /*{
          title: "手续费",
          dataIndex: "returnServiceAmount",
          // width: 80,
          align: "center"
        },*/

        /*{
          title: "保单数",
          dataIndex: "insuranceNum",
          // width: 80,
          align: "center"
        },*/
        /*{
          title: "账单总额",
          dataIndex: "settlementAmount",
          // width: 100,
          align: "center"
        },*/

        {
          title: "操作",
          dataIndex: "",
          // width: 200,
          align: "center",
          slots: { customRender: "operation" },
          className: `${"operationStyle"}`
        }
      ],
      handleDownload,
      createBill,
      createVisible,
      id,
      templateDownload,
      createCancel,
      fileList,
      beforeUpload,
      handleRemove,
      handleUpload,
      createSpinning
    };
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.search_content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.orderCode_span {
  // color:#0D6DBF;
  cursor: pointer;
}
.changeType {
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  // font-weight: 600;
  color: #000000;
}
.first_p {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
}
.topTitle {
  background: #f8f8f8;
  padding: 8px 22px 7px 0;
  margin-bottom: 12px;
  text-align: right;
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-left: 17px;
    width: 101px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    border-radius: 4px;
  }
}
.chooseDate {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;
  img {
    width: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .ant-calendar-picker {
    width: 216px;
  }
}
.handleBtn {
  display: block;
  line-height: 1.8;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    color: #40a9ff;
  }
}
.item_content {
  padding: 0 16px 0 20px;
}
.item_content:hover {
  background: #e6f7ff !important;
}
.amount-list {
  margin-top: 13px;
  // padding: 0 16px 0 20px;
  border: 0.5px solid #dbdce0;
  padding: 6px 0;
  // padding-bottom: 250px;
  .item {
    padding: 15px 0 6px 0;
    border-bottom: 1px solid #dbdce0;
    .item-left {
      & div {
        display: inline-block;
      }
      .changeType {
        vertical-align: top;
        font-size: 14px;
        line-height: 22px;
        margin-right: 22px;
      }
      .info {
        color: #000000;
        font-family: PingFangSC-Light, PingFang SC;
        font-size: 14px;
        line-height: 20px;

        & span:nth-of-type(2) {
          font-family: PingFangSC-Light, PingFang SC;
          color: #929395;
        }
      }
    }
    .item-right {
      text-align: right;
      font-size: 16px;
      line-height: 22px;
      color: #929395;
    }
  }
  .item_content:last-of-type {
    .item {
      border: none;
    }
  }
  .ant-pagination {
    text-align: center;
    margin-top: 40px !important;
  }
}
.creatRow {
  border: 1px solid #f5f5f5;
  margin-bottom: 15px;
  .ant-col-4 {
    text-align: center;
    font-size: 30px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
      color: #666;
    }
    &:nth-of-type(3) {
      color: #40a9ff;
      cursor: pointer;
    }
  }
  .handle {
    line-height: 1.5;
    margin-top: 0;
    margin-bottom: 10px;
    color: #40a9ff;
    cursor: pointer;
  }
}
.tipRow {
  border: 1px solid #ffe58f;
  margin-bottom: 15px;
  background: #fffbe6;
  color: #888;
  .ant-col-3 {
    text-align: center;
    font-size: 20px;
  }
  p {
    line-height: 1.5;
    margin: 10px 0;
    &:nth-of-type(1) {
      font-weight: bold;
    }
    &:nth-of-type(2) {
      font-size: 12px;
    }
  }
}
</style>
